export default "__VITE_ASSET__$AjKo7ig__"